import createAxios from '@/app/core/AxiosCore';
import config from '@/app/config/app';

const axios = createAxios(config);

function listar(paginacao) {
  return axios.get('financeiro/categorias', { params: paginacao }).then((response) => response.data);
}

function abrir(id) {
  return axios.get(`financeiro/categorias/${id}`).then((response) => response.data);
}

function salvar(categoria) {
  return axios.post('financeiro/categorias', categoria).then((response) => response.data);
}

function atualizar(categoria) {
  return axios.put(`financeiro/categorias/${categoria.id}`, categoria).then((response) => response.data);
}

function excluir(id) {
  return axios.delete(`financeiro/categorias/${id}`).then((response) => response.data);
}

export default {
  listar,
  abrir,
  salvar,
  atualizar,
  excluir,
};
